import { getGridColumns, getItemWidth, getWidgetLayoutType } from "../utilities/widgetHelper";
import { FilterOption, modeFilterSet, riskLevelFilterSet, statusFilterEnum, statusFilterSet, dateRangesEnum, dateRangesFilterSet } from "./filterItem"
import { UserWidget } from "./online.homepagegateway.api";
import { WidgetId } from "./widgetId";
import { WidgetLayoutType } from "./widgetLayoutType";

export const defaultWidgets = (windowWidth: number) => {
    const layoutType = getWidgetLayoutType(windowWidth);
    const gridColumns = getGridColumns(windowWidth);

    const isSingleTileLayout = layoutType === WidgetLayoutType.SingleTileLayout;

    const getStatuses = () => {
        const defaultStatus = [statusFilterEnum.Booked, statusFilterEnum.InTransit, statusFilterEnum.Delivered];
        const status: FilterOption[] = [];
        statusFilterSet.forEach((option) => {
            const found = defaultStatus.find(a => a === option.key);
            if (found) {
                option.active = true
            }
            status.push(option);
        });
        return status;
    }

    const getDateRanges = () => {
        const defaultDateRanges = [dateRangesEnum.New, dateRangesEnum.Requested_Pickup_Today, dateRangesEnum.Requested_Pickup_This_Week];
        const dateRanges: FilterOption[] = [];
        dateRangesFilterSet.forEach((option) => {
            const found = defaultDateRanges.find(a => a === option.key);
            if (found) {
                option.active = true
            }
            dateRanges.push(option);
        });
        return dateRanges;
    }

    const widgetData: UserWidget[] =
    [
        {
            widgetId: WidgetId.Orders,
            title: ("My Orders at a Glance"),
            name: "Orders",
            dataModelOptions: {
                statuses: getStatuses(),
                riskLevels: riskLevelFilterSet,
                shippingMethods: modeFilterSet,
                timeFrames: getDateRanges(),
            },
            layouts: [{id: "1", x: 0, y: 0, layoutType: WidgetLayoutType.Default},{id: "1", x: 0, y: 0, layoutType: WidgetLayoutType.SingleTileLayout}],
            currentLayout: {
                id: "1",
                x: 0,
                y: 0,
                height: 1,
                width: getItemWidth(WidgetId.Orders, gridColumns),
                forceRender: 0,
                layoutType: layoutType
            },
            id: 1
        },
        {
            widgetId: WidgetId.RecentOrders,
            title: ("Recently viewed"),
            name: "Recently viewed",
            dataModelOptions: {
                statuses: getStatuses(),
                riskLevels: riskLevelFilterSet,
                shippingMethods: modeFilterSet,
                timeFrames: getDateRanges(),
            },
            layouts: [{id: "2", x: getItemWidth(WidgetId.RecentOrders, gridColumns), y: 0, layoutType: WidgetLayoutType.Default},{id: "2", x: 0 , y: 1, layoutType: WidgetLayoutType.SingleTileLayout}],
            currentLayout: {
                id: "2",
                x: (isSingleTileLayout ? 0 : getItemWidth(WidgetId.RecentOrders, gridColumns)),
                y: (isSingleTileLayout ? 1 : 0),
                height: 1,
                width: getItemWidth(WidgetId.RecentOrders, gridColumns),
                forceRender: 0,
                layoutType: layoutType
            },
            id: 2
        },
        {
            widgetId: WidgetId.Shipments,
            title: ("My Shipments at a Glance"),
            name: "Shipments",
            dataModelOptions: {
                statuses: getStatuses(),
                riskLevels: riskLevelFilterSet,
                shippingMethods: modeFilterSet,
                timeFrames: getDateRanges(),
            },
            layouts: [{id: "3", x: 0, y: 1, layoutType: WidgetLayoutType.Default},{id: "3", x: 0, y: 2, layoutType: WidgetLayoutType.SingleTileLayout}],
            currentLayout: {
                id: "3",
                x: 0,
                y: (isSingleTileLayout ? 2 : 1),
                height: 1,
                width: getItemWidth(WidgetId.Shipments, gridColumns),
                forceRender: 0,
                layoutType: layoutType
            },
            id: 3
        },
    ]

    return widgetData;
}
